// src/components/GoldRateConfigModal.jsx
import React, { useState } from "react";
import {
  Modal,
  Box,
  Typography,
  TextField,
  Button,
  Paper,
  Stack,
  Alert,
} from "@mui/material";
import { useGoldRate } from "../context/GoldRateContext";

const GoldRateConfigModal = ({ open, onComplete }) => {
  const { updateRates, rates } = useGoldRate();
  const [formData, setFormData] = useState({
    "18carat": rates?.["18carat"] || 4500,
    "22carat": rates?.["22carat"] || 5500,
    "24carat": rates?.["24carat"] || 6000,
  });
  const [error, setError] = useState("");

  const handleChange = (carat, value) => {
    setFormData((prev) => ({
      ...prev,
      [carat]: parseFloat(value) || 0,
    }));
  };

  const handleSave = () => {
    // Validate rates
    for (const [carat, rate] of Object.entries(formData)) {
      if (rate <= 0 || isNaN(rate)) {
        setError(`Please enter a valid rate for ${carat}`);
        return;
      }
      if (rate > 20000) {
        setError(`Rate seems too high for ${carat}. Please check.`);
        return;
      }
    }

    updateRates(formData);
    setError("");
    if (onComplete) onComplete();
  };

  return (
    <Modal open={open} onClose={() => {}} disableEscapeKeyDown>
      <Paper
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: { xs: "90%", sm: 450 },
          maxHeight: "90vh",
          p: 3,
          borderRadius: 3,
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: 2,
          }}
        >
          <Typography variant="h6" fontWeight="bold">
            Set Gold Rates
          </Typography>
        </Box>

        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
          Please set current gold rates per gram. This will be used to calculate
          item prices when scanning.
        </Typography>

        {error && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}

        <Stack spacing={3}>
          <TextField
            label="18 Carat Gold Rate (per gram)"
            type="number"
            value={formData["18carat"]}
            onChange={(e) => handleChange("18carat", e.target.value)}
            fullWidth
            InputProps={{ startAdornment: <Typography mr={1}>₹</Typography> }}
          />

          <TextField
            label="22 Carat Gold Rate (per gram)"
            type="number"
            value={formData["22carat"]}
            onChange={(e) => handleChange("22carat", e.target.value)}
            fullWidth
            InputProps={{ startAdornment: <Typography mr={1}>₹</Typography> }}
          />

          <TextField
            label="24 Carat Gold Rate (per gram)"
            type="number"
            value={formData["24carat"]}
            onChange={(e) => handleChange("24carat", e.target.value)}
            fullWidth
            InputProps={{ startAdornment: <Typography mr={1}>₹</Typography> }}
          />
        </Stack>

        <Box sx={{ display: "flex", gap: 2, mt: 4 }}>
          <Button
            variant="contained"
            onClick={handleSave}
            fullWidth
            sx={{ py: 1.5 }}
          >
            Save Rates
          </Button>
        </Box>
      </Paper>
    </Modal>
  );
};

export default GoldRateConfigModal;
